var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_7948_13429)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 251,
    height: 251,
    rx: 125.5,
    fill: "url(#paint0_linear_7948_13429)",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7948_13429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.1294 193.765L115.684 134.56H86.3203L121.682 61.1635L154.627 61.1572L134.567 107.296H166.015L95.3258 199.555L97.1294 193.765Z",
    fill: "#FDC535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.684 134.559H86.3203L118.656 67.4482H138.844C139.192 67.4482 139.535 67.5348 139.841 67.7002C140.147 67.8655 140.407 68.1045 140.598 68.3955C140.789 68.6865 140.904 69.0204 140.934 69.3671C140.964 69.7139 140.907 70.0625 140.768 70.3816L123.259 110.654C123.12 110.973 123.063 111.321 123.092 111.668C123.122 112.015 123.237 112.349 123.428 112.64C123.619 112.931 123.879 113.17 124.185 113.335C124.491 113.5 124.834 113.587 125.182 113.587H149.183C149.574 113.587 149.957 113.697 150.29 113.903C150.622 114.11 150.89 114.405 151.063 114.756C151.237 115.107 151.308 115.499 151.27 115.889C151.232 116.278 151.085 116.649 150.847 116.96L100.677 182.445L115.684 134.559Z",
    fill: "#FFEE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3107 201.671C94.9817 201.67 94.6575 201.593 94.3641 201.444C94.0707 201.295 93.8163 201.08 93.6217 200.815C93.427 200.55 93.2974 200.242 93.2434 199.918C93.1894 199.593 93.2125 199.261 93.3108 198.947L112.83 136.657H86.3239C85.969 136.657 85.6199 136.567 85.3093 136.395C84.9986 136.223 84.7367 135.976 84.5479 135.675C84.3591 135.375 84.2497 135.031 84.2298 134.677C84.21 134.322 84.2804 133.969 84.4345 133.649L119.787 60.2464C119.958 59.8908 120.227 59.5908 120.561 59.3809C120.895 59.1709 121.282 59.0596 121.677 59.0596H154.633C154.981 59.0596 155.324 59.1462 155.63 59.3116C155.936 59.477 156.196 59.716 156.387 60.007C156.578 60.2981 156.693 60.6321 156.723 60.9788C156.752 61.3256 156.695 61.6742 156.556 61.9934L137.759 105.198H166.018C166.41 105.198 166.793 105.308 167.126 105.514C167.458 105.721 167.726 106.016 167.899 106.367C168.073 106.718 168.144 107.111 168.106 107.5C168.068 107.89 167.921 108.261 167.683 108.572L96.9769 200.849C96.7808 201.105 96.5285 201.312 96.2396 201.454C95.9506 201.597 95.6328 201.671 95.3107 201.671ZM89.6622 132.462H115.685C116.014 132.462 116.338 132.54 116.632 132.689C116.925 132.837 117.18 133.053 117.375 133.318C117.57 133.583 117.699 133.89 117.753 134.215C117.807 134.54 117.784 134.872 117.686 135.186L100.859 188.887L161.77 109.393H134.56C134.212 109.393 133.869 109.306 133.563 109.141C133.257 108.975 132.997 108.736 132.806 108.445C132.615 108.154 132.5 107.82 132.47 107.474C132.441 107.127 132.498 106.778 132.637 106.459L151.434 63.254H122.994L89.6622 132.462Z",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 246,
    height: 246,
    rx: 123,
    stroke: "url(#paint1_linear_7948_13429)",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_7948_13429",
    x: -20,
    y: -20,
    width: 291,
    height: 291,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_7948_13429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_7948_13429",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_7948_13429"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_7948_13429",
    result: "effect3_innerShadow_7948_13429"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7948_13429",
    x1: 33.6618,
    y1: -58.4339,
    x2: 342.027,
    y2: 154.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD835",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7948_13429",
    x1: 125.5,
    y1: 0,
    x2: 125.5,
    y2: 251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7948_13429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151,
    height: 151,
    fill: "white",
    transform: "translate(50 50)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame24);
export default __webpack_public_path__ + "static/media/Frame_24.5807ed1a1dd0e0c3fe9ca7c82feff400.svg";
export { ForwardRef as ReactComponent };